import { render } from "./IabRequirements.vue?vue&type=template&id=31c82819"
import script from "./IabRequirements.vue?vue&type=script&lang=js"
export * from "./IabRequirements.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__